/* eslint-disable */
/**
* Ortho Team Api
* No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
*
* OpenAPI spec version: v1
* 
*
* NOTE: This class is auto generated by the swagger code generator program.
* https://github.com/swagger-api/swagger-codegen.git
* Do not edit the class manually.
*/


import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { FormFieldInstanceDto } from '../model/formFieldInstanceDto';
import { FormInstanceCanvasImagesDto } from '../model/formInstanceCanvasImagesDto';
import { FormInstanceDto } from '../model/formInstanceDto';
import { FormInstanceHeaderDto } from '../model/formInstanceHeaderDto';
import { FormInstanceSearchDto } from '../model/formInstanceSearchDto';
import { FormInstanceSearchDtoSearchResponse } from '../model/formInstanceSearchDtoSearchResponse';
import { FormInstanceSearchRequestDto } from '../model/formInstanceSearchRequestDto';
import { SaveFormFieldDto } from '../model/saveFormFieldDto';
import { SendFormEmailRequestDto } from '../model/sendFormEmailRequestDto';
import { UploadPolicy } from '../model/uploadPolicy';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FormInstanceService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _delete(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public _delete(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public _delete(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public _delete(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling _delete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.delete(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadPdfRequest(id: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public downloadPdfRequest(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public downloadPdfRequest(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public downloadPdfRequest(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling downloadPdfRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(id))}/download/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param orderNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicateFormInstance(id: string, orderNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<FormInstanceSearchDto>;
    public duplicateFormInstance(id: string, orderNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FormInstanceSearchDto>>;
    public duplicateFormInstance(id: string, orderNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FormInstanceSearchDto>>;
    public duplicateFormInstance(id: string, orderNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling duplicateFormInstance.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderNumber !== undefined && orderNumber !== null) {
            queryParameters = queryParameters.set('orderNumber', <any>orderNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.put(`${this.basePath}/api/FormInstance/duplicate/${encodeURIComponent(String(id))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public geInstanceBackgroundImageRequest(formId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public geInstanceBackgroundImageRequest(formId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public geInstanceBackgroundImageRequest(formId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public geInstanceBackgroundImageRequest(formId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling geInstanceBackgroundImageRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling geInstanceBackgroundImageRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/instanceBackgroundImage/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public get(id: string, observe?: 'body', reportProgress?: boolean): Observable<FormInstanceDto>;
    public get(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FormInstanceDto>>;
    public get(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FormInstanceDto>>;
    public get(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling get.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCombinedImageRequest(formId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getCombinedImageRequest(formId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getCombinedImageRequest(formId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getCombinedImageRequest(formId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getCombinedImageRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getCombinedImageRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/combinedImage/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param filename 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDownloadRequest(formId: string, fieldId: string, filename: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getDownloadRequest(formId: string, fieldId: string, filename: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getDownloadRequest(formId: string, fieldId: string, filename: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getDownloadRequest(formId: string, fieldId: string, filename: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getDownloadRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getDownloadRequest.');
        }
        if (filename === null || filename === undefined) {
            throw new Error('Required parameter filename was null or undefined when calling getDownloadRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/${encodeURIComponent(String(filename))}/download/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDrawingImageRequest(formId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getDrawingImageRequest(formId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getDrawingImageRequest(formId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getDrawingImageRequest(formId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getDrawingImageRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getDrawingImageRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/drawingImage/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFormInstanceByOrder(body?: FormInstanceSearchRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<FormInstanceHeaderDto>>;
    public getFormInstanceByOrder(body?: FormInstanceSearchRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FormInstanceHeaderDto>>>;
    public getFormInstanceByOrder(body?: FormInstanceSearchRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FormInstanceHeaderDto>>>;
    public getFormInstanceByOrder(body?: FormInstanceSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/FormInstance/order-form-instances`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getImages(formId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<FormInstanceCanvasImagesDto>;
    public getImages(formId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FormInstanceCanvasImagesDto>>;
    public getImages(formId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FormInstanceCanvasImagesDto>>;
    public getImages(formId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getImages.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getImages.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/canvasImages`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUploadCombinedImageRequest(formId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<UploadPolicy>;
    public getUploadCombinedImageRequest(formId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadPolicy>>;
    public getUploadCombinedImageRequest(formId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadPolicy>>;
    public getUploadCombinedImageRequest(formId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getUploadCombinedImageRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getUploadCombinedImageRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/uploadCombinedImage/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUploadDrawingImageRequest(formId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<UploadPolicy>;
    public getUploadDrawingImageRequest(formId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadPolicy>>;
    public getUploadDrawingImageRequest(formId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadPolicy>>;
    public getUploadDrawingImageRequest(formId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getUploadDrawingImageRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getUploadDrawingImageRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/uploadDrawingImage/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param fileName 
     * @param filetype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUploadFileRequest(formId: string, fieldId: string, fileName: string, filetype: string, observe?: 'body', reportProgress?: boolean): Observable<UploadPolicy>;
    public getUploadFileRequest(formId: string, fieldId: string, fileName: string, filetype: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadPolicy>>;
    public getUploadFileRequest(formId: string, fieldId: string, fileName: string, filetype: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadPolicy>>;
    public getUploadFileRequest(formId: string, fieldId: string, fileName: string, filetype: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getUploadFileRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getUploadFileRequest.');
        }
        if (fileName === null || fileName === undefined) {
            throw new Error('Required parameter fileName was null or undefined when calling getUploadFileRequest.');
        }
        if (filetype === null || filetype === undefined) {
            throw new Error('Required parameter filetype was null or undefined when calling getUploadFileRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/${encodeURIComponent(String(fileName))}/${encodeURIComponent(String(filetype))}/upload/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param formId 
     * @param fieldId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUploadInstanceBackgroundImageRequest(formId: string, fieldId: string, observe?: 'body', reportProgress?: boolean): Observable<UploadPolicy>;
    public getUploadInstanceBackgroundImageRequest(formId: string, fieldId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadPolicy>>;
    public getUploadInstanceBackgroundImageRequest(formId: string, fieldId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadPolicy>>;
    public getUploadInstanceBackgroundImageRequest(formId: string, fieldId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (formId === null || formId === undefined) {
            throw new Error('Required parameter formId was null or undefined when calling getUploadInstanceBackgroundImageRequest.');
        }
        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling getUploadInstanceBackgroundImageRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

    return this.httpClient.get(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(formId))}/${encodeURIComponent(String(fieldId))}/uploadInstanceBackgroundImage/request`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveField(id: string, body?: SaveFormFieldDto, observe?: 'body', reportProgress?: boolean): Observable<FormFieldInstanceDto>;
    public saveField(id: string, body?: SaveFormFieldDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FormFieldInstanceDto>>;
    public saveField(id: string, body?: SaveFormFieldDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FormFieldInstanceDto>>;
    public saveField(id: string, body?: SaveFormFieldDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling saveField.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/FormInstance/${encodeURIComponent(String(id))}/field`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchForms(body?: FormInstanceSearchRequestDto, observe?: 'body', reportProgress?: boolean): Observable<FormInstanceSearchDtoSearchResponse>;
    public searchForms(body?: FormInstanceSearchRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FormInstanceSearchDtoSearchResponse>>;
    public searchForms(body?: FormInstanceSearchRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FormInstanceSearchDtoSearchResponse>>;
    public searchForms(body?: FormInstanceSearchRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/FormInstance/search`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendFormEmail(body?: SendFormEmailRequestDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public sendFormEmail(body?: SendFormEmailRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public sendFormEmail(body?: SendFormEmailRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public sendFormEmail(body?: SendFormEmailRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

    return this.httpClient.post(`${this.basePath}/api/FormInstance/sendEmail`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
